/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  totalAnswers: {
    fontWeight: "600",
    fontSize: "14px",
    color: "black",
    padding: "10px 0px",
  },
  totalAnswersSpan: {
    fontWeight: "500",
  },
});

function SurveyCardFooter({ total, postfix = "", textSize = 1.0 }) {
  const classes = useStyles();
  const totalAnswersTitle = I18n.t("surveys.answers.index");

  // Font sizes in rem for "Answers:" footer (base: 14px / 10px = 1.4rem)
  const answersFontSize = `${String(1.4 * textSize)}rem`;
  const answersPadding = `${String(1.0 * textSize)}rem 0`; // 10px / 10px = 1.0rem
  const answersMargin = `${String(0.6 * textSize)}rem 0`; // 6px / 10px = 0.6rem

  return (
    <p
      className={classes.totalAnswers}
      style={{
        fontSize: answersFontSize,
        padding: answersPadding,
        margin: answersMargin,
      }}
    >
      {`${totalAnswersTitle}: `}
      <span className={classes.totalAnswersSpan}>
        {total}
        {postfix}
      </span>
    </p>
  );
}

SurveyCardFooter.propTypes = {
  total: PropTypes.number,
  postfix: PropTypes.string,
};

export default SurveyCardFooter;
